export function convertArrayOfObjectsToCSV(array, keys) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key];

      ctr += 1;
    });
    result += lineDelimiter;
  });

  return result;
}

export function downloadCSV(array, keys) {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array, keys);

  if (csv == null) return;

  const filename = 'export.csv';

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
}
